(function (appSetup) {

	appSetup.routerFactory = function (app) {

		var router = {
			initialized: false,
			historyActions: {
				push: "push",
				replace: "replace"
			},
			get path() {
				var path = window.location.pathname;
				return path;
			},
			get params() {
				var params = location.search.substr(1);
				return params;
			},
			init: function () {
				app.core.handlers.onSwitchToPath(this.path, this.params);

				this.bindings();
				router.initialized = true;
			},
			writeHistory: function (action, path, params) {
				var state = {
					path: path,
					params: params
				};

				if (params) {
					path = path + "?" + params;
				}

				if (!router.initialized || action == router.historyActions.replace) {
					history.replaceState(state, "", path);
				} else if (action == router.historyActions.push) {
					history.pushState(state, "", path);
				}
			},
			goTo: function (path, params) {
				if (path.charAt(0) == "/") {
					path = path.substr(1);
				}
				var url = window.location.origin + "/" + path;
				if (params) {
					url = url + "?" + params;
				}
				if (url.toLowerCase().indexOf("/enetebg/") >= 0 || url.toLowerCase().indexOf("enetmms") >= 0)
				{
					window.open(url,'_blank');
				}
				else
				{
					window.location.href = url;
				}
			},
			goBack: function () {
				window.history.go(-1);
			},
			bindings: function () {
				window.onpopstate = function (e) {
					if (!e.state) {
						if (window.location.hash != null) {
							// hack to allow wiz acc plug to run its routine but stop user from interaction with hash history
							setTimeout(function () {
								window.history.replaceState("", document.title, window.location.pathname + window.location.search);
							}, 500);
						}
						return;
					}
					var state = e.state;
					var ignoreWriteHistory = true;
					var params = {
						path: state.path,
						params: state.params,
						ignoreWriteHistory: ignoreWriteHistory
					};
					app.core.handlers.onHistoryPopState(params);
				};
			}
		};
		return router;
	};

	window.appSetup = appSetup;

})(window.appSetup || {});